import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['modal', 'overlay'];

  connect() {
    this.storageKey = 'part_time_reward_alert_last_shown_month';

    if (this.shouldShowModal()) {
      this.showModal();
    }
  }

  shouldShowModal() {
    const today = new Date();
    const day = today.getDate();
    if (day > 15) return false;

    return localStorage.getItem(this.storageKey) !== this.currentMonth();
  }

  currentMonth() {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`;
  }

  showModal() {
    if (this.hasModalTarget && this.hasOverlayTarget) {
      this.modalTarget.classList.remove('is-hide');
      this.modalTarget.classList.add('is-show');
      this.overlayTarget.classList.remove('is-hide');
      this.overlayTarget.classList.add('is-show');
    }
  }

  close() {
    if (this.hasModalTarget && this.hasOverlayTarget) {
      this.modalTarget.classList.remove('is-show');
      this.modalTarget.classList.add('is-hide');
      this.overlayTarget.classList.remove('is-show');
      this.overlayTarget.classList.add('is-hide');

      localStorage.setItem(this.storageKey, this.currentMonth());
    }
  }
}
